// File: cgp-snackbar.service.ts
// Author: Joseph M Diaz
// Date: 5/4/2017
// Desc: CGP Snackbar component.
// Other Contributors:

import { Injectable } from '@angular/core';
import { MatLegacySnackBar as MatSnackBar } from '@angular/material/legacy-snack-bar';

const defaults = {
    message: '',
    action: '',
    type: 'accept',
    duration: 5000,
    onAction: null
};

export const cgpSnackbarTypes = {
    accept: 'accept',
    warning: 'warning',
    cancel: 'cancel'
};

@Injectable()
export class CgpSnackbarService {
    constructor(private readonly snackbar: MatSnackBar) {}

    showSnackbar(opts) {
        const options = {
            ...defaults,
            ...opts
        };
        const snackbarRef = this.snackbar.open(options.message, options.action, { duration: options.duration, panelClass: [options.type] });

        snackbarRef.onAction().subscribe(() => {
            if (options.onAction) {
                options.onAction();
            }
        });

        return snackbarRef;
    }
}